module.exports = __webpack_public_path__ + "static/media/angle-up.b4f745a7.svg";